import axios from '@/components/api/axios';

async function findByTag(data) {
  const res = await axios.axiosGet('/api/fanClub/articles/findByTag', data);
  return res;
}

async function getArticle(data) {
  const res = await axios.axiosGet('/api/fanClub/articles/getArticle', data);
  return res;
}

async function getArticleList(data) {
  const res = await axios.axiosGet('/api/fanClub/articles/getArticleList', data);
  return res;
}

async function getRankingList() {
  const res = await axios.axiosGet('/api/fanClub/articles/getRankingList', null);
  return res;
}

async function getRelatedArticleList(data) {
  const res = await axios.axiosGet('/api/fanClub/articles/getRelatedArticleList', data);
  return res;
}

async function getTagList() {
  const res = await axios.axiosGet('/api/fanClub/articles/getTagList', null);
  return res;
}

async function getTopicsList() {
  const res = await axios.axiosGet('/api/fanClub/articles/getTopicsList', null);
  return res;
}

async function search(data) {
  const res = await axios.axiosGet('/api/fanClub/articles/search', data);
  return res;
}

async function getAttentionArticleLists() {
  const res = await axios.axiosGet('/api/fanClub/articles/getAttentionArticle', null);
  return res;
}

export default {
  findByTag,
  getArticle,
  getArticleList,
  getRankingList,
  getTagList,
  getTopicsList,
  search,
  getRelatedArticleList,
  getAttentionArticleLists
}



// WEBPACK FOOTER //
// ./src/components/api/fanClub/article.js